import React, { useState, useEffect ,useRef} from "react";
import axiosInstance from "../Help/AxiosLogicInstance";
import { useNavigate } from "react-router-dom";
// import { State, City } from "country-state-city"; // Import the country-state-city package
import { toast } from "react-toastify";

const LaboratoryTourForm = () => {
  const navigate = useNavigate();
  // Replace with your actual auth hook
  const StudentId = localStorage.getItem("StudentId")
  const isSubmittingRef = useRef(false);
  const [isFormActive, setIsFormActive] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  
  // Check if the form is active
  useEffect(() => {
    const checkFormStatus = async () => {
      try {
        const response = await axiosInstance.get('/api/Student/GetApplicationSettingMasterByFormId/3');
        if (response.data && 
            response.data.Status === "200" && 
            response.data.Data && 
            response.data.Data.length > 0) {
          setIsFormActive(response.data.Data[0].IsActive);
        } else {
          setIsFormActive(false);
        }
      } catch (error) {
        console.error("Error fetching form status:", error);
        setIsFormActive(false);
      } finally {
        setIsLoading(false);
      }
    };
    
    checkFormStatus();
  }, [navigate]);
  
  // If form is not active, redirect to laboratory tour program page
  useEffect(() => {
    if (!isLoading && !isFormActive) {
      toast.error("Applications are currently closed. Please check back later.");
      navigate('/laboratory-tour');
    }
  }, [isFormActive, isLoading, navigate]);
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
     document.title = "Laboratory Tour Application - MedEngage";
  }, []);
  useEffect(() => {
    const loadStatesData = async () => {
      try {
        const response = await fetch('/Districts/states_districts.csv');
        const text = await response.text();
        const lines = text.split('\n').slice(1); // Skip header
        const data = lines.map(line => {
          const [state, district] = line.split(',').map(s => s.replace(/"/g, '').trim());
          return { state, district };
        }).filter(item => item.state && item.district);
        setStatesData(data);
        const uniqueStates = [...new Set(data.map(item => item.state))].sort();
        setIndianStates(uniqueStates);
      } catch (error) {
        console.error('Error loading states data:', error);
      }
    };
    loadStatesData();
  }, []);
     
  // Get all Indian states using the country-state-city package
  // const indianStates = State.getStatesOfCountry("IN");

  // State for city/district options based on selected state
  const [cityOptions, setCityOptions] = useState([]);
  const [statesData, setStatesData] = useState([]);
  const [indianStates, setIndianStates] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    dob: "",
    email: "",
    contactNumber: "",
    collegeName: "",
    collegeID: null,
    collegeAddress: "",
    qualification: "",
    courseYear: "",
    city: "",
    state: "",
    pincode: "",
    fromDate: "",
    toDate: "",
    groupSize: "",
    duration: "",
    labTheme: "",
    labThemeOther: "",
    labRationale: "",
    labCareerImpact: "",
    heardAbout: "",
    heardAboutOther: "",
    preferredLabLocation: "",
    preferredLabLocationOther: "",
    applicantSignature: null,
    agreeTerms: false,
  });
  useEffect(() => {
    if (formData.state && statesData.length > 0) {
      const districts = statesData
        .filter(item => item.state === formData.state)
        .map(item => item.district)
        .sort();
      setCityOptions(districts);
    } else {
      setCityOptions([]);
    }
  }, [formData.state, statesData]);

  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

const handleChange = (e) => {
  const { name, value, type, checked, files } = e.target;
  let updatedValue;

  if (type === "checkbox") {
    updatedValue = checked;
  } else if (type === "file") {
    const file = files[0];
    const validTypes = ["image/jpeg", "image/png"];
    if (file && file.size > 10 * 1024 * 1024) {
      toast.error("File must be ≤ 10MB");
      // Clear the file input so user can re-select
      e.target.value = "";
      return;
    }
    if (file && !validTypes.includes(file.type)) {
      toast.error("Invalid file type. Only JPG, PNG allowed");
      e.target.value = "";
      return;
    }
    updatedValue = file;
  } else if (name === "state") {
    // Special handling for state selection
    setFormData(prev => ({
      ...prev,
      state: value,
      city: "" // Reset city when state changes
    }));
    
    // Clear errors
    setErrors((prev) => ({
      ...prev,
      [name]: undefined,
      city: undefined
    }));
    return;
  } else {
    // Allow spaces during typing - trimming happens on blur
    updatedValue = value;
  }

  setFormData((prev) => ({
    ...prev,
    [name]: updatedValue,
  }));

  // Clear the error for this field as soon as user types/selects
  setErrors((prev) => ({
    ...prev,
    [name]: undefined,
  }));
};

const handleBlur = (e) => {
  const { name, value } = e.target;
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (trimmed !== value) {
      // Update local form state
      setFormData(prev => ({ ...prev, [name]: trimmed }));
      // Show field-specific toast message
      // toast.warning(`Leading or trailing spaces removed from ${name}`);
    }
  }

  // Run validation after trimming
  setSubmitted(true);
  validate();
};

const fieldRefs = {
  name: useRef(),
  email: useRef(),
  contactNumber: useRef(),
  collegeName: useRef(),
  collegeAddress: useRef(),
  qualification: useRef(),
  courseYear: useRef(),
  city: useRef(),
  state: useRef(),
  pincode: useRef(),
  duration: useRef(),
  labTheme: useRef(),
  labRationale: useRef(),
  labCareerImpact: useRef(),
  heardAbout: useRef(),
  agreeTerms: useRef(),
  // Add refs for other required fields as needed
};

// Helper function for leading/trailing spaces
function hasLeadingOrTrailingSpace(str) {
  return typeof str === "string" && str.trim() !== str;
}

const validate = () => {
  let tempErrors = {};
  const requiredFields = [
    "name", "email", "contactNumber", "collegeName","collegeID","state",
   
    "collegeAddress", "qualification", "courseYear", "city",
    "pincode", "duration", "labTheme",
    "labRationale", "labCareerImpact", "heardAbout", "agreeTerms",
  
  ];

  requiredFields.forEach(field => {
    if (
      !formData[field] ||
      (typeof formData[field] === "string" && formData[field].trim() === "")
    ) {
      tempErrors[field] = "Required";
    }
  });
  
  // Email validation with proper regex
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (formData.email) {
    // Check for spaces in email
    // if (formData.email.trim() !== formData.email) {
    //   tempErrors.email = "No leading or trailing spaces allowed";
    // } 
     if (!emailRegex.test(formData.email)) {
      tempErrors.email = "Invalid email format (e.g., abc@test.com)";
    }
  }

  // Pincode validation
  if (formData.pincode && !/^\d{6}$/.test(formData.pincode)) {
    tempErrors.pincode = "Pincode should be exactly 6 digits";
  }
  
  // Name validation - only alphabets and spaces
  const nameFields = [
    "name",
    "collegeName",
    "qualification",
    "labThemeOther",
    "heardAboutOther",
    "preferredLabLocationOther"
    // Add other name-like fields as needed
  ];
  nameFields.forEach((field) => {
    if (formData[field] && !/^[A-Za-z ]+$/.test(formData[field].trim())) {
      tempErrors[field] = "Only letters and spaces allowed";
    }
  });

  // Date of birth validation
  if (formData.dob) {
    const dobDate = new Date(formData.dob);
    const today = new Date();
    if (dobDate > today) {
      tempErrors.dob = "Date of birth cannot be in the future";
    }
  }

  // Date validation
  if (formData.fromDate && formData.toDate && formData.toDate < formData.fromDate) {
    tempErrors.toDate = "End Date must be greater than or equal to Start Date";
  }

  // College address validation - allow only alphanumeric + basic punctuation
  const addressRegex = /^[a-zA-Z0-9\s,.\-\/#]+$/;
  if (formData.collegeAddress && !addressRegex.test(formData.collegeAddress.trim())) {
    tempErrors.collegeAddress = "Address can only contain letters, numbers, spaces, and basic punctuation (,.-/#)";
  }
  
  // Phone number validation
  const phoneRegex = /^(\+91\s?)?\d{5}\s?\d{5}$/;
  if (formData.contactNumber && !phoneRegex.test(formData.contactNumber.trim())) {
    tempErrors.contactNumber = "Use: +91 91522 11510 or 9152211510";
  }

  // Conditional validation for "Other"
  if (formData.qualification === "Other" && !formData.qualificationOther) {
    tempErrors.qualificationOther = "Please specify";
  }
  if (formData.labTheme === "Other" && !formData.labThemeOther) {
    tempErrors.labThemeOther = "Please specify";
  }
  if (formData.heardAbout === "Other" && !formData.heardAboutOther) {
    tempErrors.heardAboutOther = "Please specify";
  }
  if (formData.preferredLabLocation === "Other" && !formData.preferredLabLocationOther) {
    tempErrors.preferredLabLocationOther = "Please specify";
  }

  // Check ALL string fields for leading/trailing spaces
  // This runs AFTER all the specific validations above, so field-specific errors have priority
  Object.keys(formData).forEach(field => {
    const val = formData[field];
    if (typeof val === "string" && val && hasLeadingOrTrailingSpace(val)) {
      // Only set this generic error if no specific error exists for this field
      // if (!tempErrors[field]) {
      //   tempErrors[field] = "No leading or trailing spaces allowed";
        // Note: The actual trimming and toast happens in handleBlur, not here
      }
  
  });

  setErrors(tempErrors);
  return tempErrors;
};


  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // If already loading or submitting, prevent multiple submissions
    if (loading || isSubmittingRef.current) {
      toast.info("Your form is being processed, please wait...");
      return;
    }
    
    isSubmittingRef.current = true; // Mark as submitting
    setSubmitted(true);
    const validationErrors = validate(); 
    setErrors(validationErrors);// get the errors object directly
    
    if (Object.keys(validationErrors).length === 0) {
      // Set loading state to prevent multiple submissions
      setLoading(true);
      
      try {
        // Map formData to API payload
        let collegeIDBase64 = "";
        let applicantSignatureBase64 = "";
        
        if (formData.collegeID) {
          const reader = new FileReader();
          collegeIDBase64 = await new Promise((resolve, reject) => {
            reader.onload = () => resolve(reader.result.split(',')[1]);
            reader.onerror = reject;
            reader.readAsDataURL(formData.collegeID);
          });
        }
        
        // Convert applicant signature to base64 if it exists
        if (formData.applicantSignature) {
          const reader = new FileReader();
          applicantSignatureBase64 = await new Promise((resolve, reject) => {
            reader.onload = () => resolve(reader.result.split(',')[1]);
            reader.onerror = reject;
            reader.readAsDataURL(formData.applicantSignature);
          });
        }
      const payload = {
        Id: 0,
        Username: formData.name,
        NameCollege: formData.collegeName,
       Email: formData.email,
        ContactNo: formData.contactNumber,
        Qualification: formData.qualification,
        State: formData.state,
        City: formData.city,
        Pincode: formData.pincode,
        Address: formData.collegeAddress,
        Hours: formData.duration,
        Interest: formData.labTheme,
        OtherInterest: formData.labThemeOther || "",
        ReachedLocation: formData.preferredLabLocation,
        Purpose: formData.labCareerImpact,
        CreatedAt: new Date().toISOString(),
        UpdatedAt: new Date().toISOString(),
        StudentId: StudentId || "",
        OtherCollege: "", 
        CourseYear: formData.courseYear,
        Rationals: formData.labRationale,
        ThemeTour: formData.labTheme,
        OtherQualification: formData.qualificationOther || "",
        ThemeTourOther: formData.labThemeOther || "",
         Dob: formData.dob || null,
        CollegeID: collegeIDBase64,
        FromDate: formData.fromDate || null,
        ToDate: formData.toDate || null,
        GroupSize: parseInt(formData.groupSize) || null,
        PreferredLabLocationOther: formData.preferredLabLocationOther || "",
        ApplicantSignature: applicantSignatureBase64,
        AgreeTerms: formData.agreeTerms || false,
        HeardAboutOther: formData.heardAboutOther || "",
          HeardAbout: formData.heardAbout
      };

      // Submit the form data
      const res = await axiosInstance.post(
        "api/Student/LaboratoryTourRegistration",
        payload
      );
      
      if (res.data.Status === "200") {
        // Use the reference ID from the API response
        const referenceId = res.data.ReferenceId;
        
        toast.success("Application submitted successfully!");
        navigate("/success", {
          state: {
            referenceId,
            name: formData.name,
            email: formData.email,
            formType: "Laboratory Tour Application"
          },
        });
      } else {
        toast.error("Submission failed. Please try again.");
      }
    } catch (err) {
      console.error("Error submitting form:", err);
      toast.error(err.response?.data?.Message || "An error occurred. Please try again.");
    } finally {
      // Reset loading state regardless of success or failure
      setLoading(false);
      isSubmittingRef.current = false; // Reset submitting state
    }
    } else {
      const firstErrorField = Object.keys(validationErrors).find(
        (key) => validationErrors[key] && fieldRefs[key]
      );
      if (firstErrorField && fieldRefs[firstErrorField]?.current) {
        fieldRefs[firstErrorField].current.scrollIntoView({ behavior: "smooth", block: "center" });
        fieldRefs[firstErrorField].current.focus();
      }
      toast.error("Please fill all required fields");
      isSubmittingRef.current = false; // Reset submitting state on validation failure
    }
  };

  return (
    <div className="container-fluid py-5">
      <div className="form-container">
        <h2 className="text-center form-heading">
          <span className="green">Laboratory Tour</span> Application
        </h2>
        <form onSubmit={handleSubmit} noValidate>
          {/* Basic Information */}
          <div className="section-header">Basic Information</div>
          <div className="row g-3 mb-2">
            <div className="col-md-4 mb-3">
              <label className="form-label">
                Name<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                placeholder="Enter your Name"
                className="form-control"
                name="name"
                value={formData.name}
                onChange={handleChange}
                onBlur={handleBlur}
                ref={fieldRefs.name}
              />
              {submitted && errors.name && (
                <small className="text-danger">{errors.name}</small>
              )}
            </div>
            <div className="col-md-4 mb-3">
              <label className="form-label">Date of Birth</label>
              <input
                type="date"
                className="form-control"
                name="dob"
                value={formData.dob}
                onChange={handleChange}
                max={new Date().toISOString().split("T")[0]}
                ref={fieldRefs.dob}
              />
              {submitted && errors.dob && (
                <small className="text-danger">{errors.dob}</small>
              )}
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">
                Email<span className="text-danger">*</span>
              </label>
              <input
                type="email"
                placeholder="Enter Your Email"
                className="form-control"
                name="email"
                value={formData.email}
                onChange={handleChange}
                onBlur={handleBlur}
                ref={fieldRefs.email}
              />
              {submitted && errors.email && (
                <small className="text-danger">{errors.email}</small>
              )}
            </div>
            <div className="col-md-4 mb-3">
              <label className="form-label">
                Contact Number<span className="text-danger">*</span>
              </label>
              <input
                type="tel"
                placeholder="Enter your Contact Number"
                className="form-control"
                name="contactNumber"
                value={formData.contactNumber}
                onChange={handleChange}
                onBlur={handleBlur}
                ref={fieldRefs.contactNumber}
              />
              {submitted && errors.contactNumber && (
                <small className="text-danger">{errors.contactNumber}</small>
              )}
            </div>
            <div className="col-md-4 mb-3">
              <label className="form-label">
                Name of College/Institute
                <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                placeholder="Enter College/Institute Name"
                className="form-control"
                name="collegeName"
                value={formData.collegeName}
                onChange={handleChange}
                onBlur={handleBlur}
                ref={fieldRefs.collegeName}
              />
              {submitted && errors.collegeName && (
                <small className="text-danger">{errors.collegeName}</small>
              )}
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">
                Upload College ID
                <span className="small text-muted">
                  (Accepted formats: JPG, PNG. Max size: 10 MB){" "}
                  <span className="text-danger">*</span>
                </span>
              </label>

              <div className="file-upload-wrapper">
                <label className="file-upload-btn">
                  <i className="fa fa-upload"></i>
                  Upload College ID
                  <input
                    type="file"
                    accept=".jpg,.jpeg,.png"
                    name="collegeID"
                    onChange={handleChange}
                    ref={fieldRefs.collegeID}
                  />
                </label>
                <small className="form-text text-muted">
                  Accepted formats: jpg, png, Max 10 MB
                </small>
                {/* Show selected file name */}
                {formData.collegeID && (
                  <div className="mt-1 text-success">
                    Selected file: {formData.collegeID.name}
                  </div>
                )}
                {submitted && errors.collegeID && (
                  <small className="text-danger d-block">
                    {errors.collegeID}
                  </small>
                )}
              </div>
            </div>
            <div className="col-md-4 mb-3">
              <label className="form-label">
                College Address<span className="text-danger">*</span>
              </label>
              <textarea
                className="form-control"
                rows={1}
                placeholder="College Address"
                name="collegeAddress"
                value={formData.collegeAddress}
                onChange={handleChange}
                onBlur={handleBlur}
                ref={fieldRefs.collegeAddress}
              ></textarea>
              {submitted && errors.collegeAddress && (
                <small className="text-danger">{errors.collegeAddress}</small>
              )}
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">
                Qualification<span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                name="qualification"
                value={formData.qualification}
                onChange={handleChange}
                ref={fieldRefs.qualification}
              >
                <option value="">Select Qualification</option>
                <option value="MBBS">MBBS</option>
                <option value="BSc">BSc</option>
                <option value="Other">Other</option>
              </select>
              {submitted && errors.qualification && (
                <small className="text-danger">{errors.qualification}</small>
              )}
            </div>
            {formData.qualification === "Other" && (
              <div className="mb-3">
                <label className="form-label">Please specify</label>
                <input
                  type="text"
                  className="form-control"
                  name="qualificationOther"
                  value={formData.qualificationOther || ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  ref={fieldRefs.qualificationOther}
                />
                {submitted && errors.qualificationOther && (
                  <small className="text-danger">
                    {errors.qualificationOther}
                  </small>
                )}
              </div>
            )}
            <div className="col-md-4 mb-3">
              <label className="form-label">
                State<span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                name="state"
                value={formData.state || ""}
                onChange={handleChange}
                ref={fieldRefs.state}
              >
                <option value="">Select State</option>
                {indianStates.map((state) => (
                  <option key={state} value={state}>
                    {state}
                  </option>
                ))}
              </select>
              {submitted && errors.state && (
                <small className="text-danger">{errors.state}</small>
              )}
            </div>
            <div className="col-md-4 mb-3">
              <label className="form-label">
                City<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                name="city"
                value={formData.city || ""}
                onChange={handleChange}
                ref={fieldRefs.city}
                placeholder="Enter city"
              />
              {submitted && errors.city && (
                <small className="text-danger">{errors.city}</small>
              )}
            </div>
            <div className="col-md-4 mb-3">
              <label className="form-label">
                Pincode<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                placeholder="Enter Your Pincode"
                className="form-control"
                name="pincode"
                value={formData.pincode}
                onChange={handleChange}
                onBlur={handleBlur}
                ref={fieldRefs.pincode}
              />
              {submitted && errors.pincode && (
                <small className="text-danger">{errors.pincode}</small>
              )}
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">
                Course Year<span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                name="courseYear"
                value={formData.courseYear}
                onBlur={handleBlur}
                onChange={handleChange}
                ref={fieldRefs.courseYear}
              >
                <option value="">Select your course year</option>
                <option value="1st Year MBBS">1st Year MBBS</option>
                <option value="2nd Year MBBS">2nd Year MBBS</option>
                <option value="3rd Year MBBS">3rd Year MBBS</option>
                <option value="4th Year MBBS">4th Year MBBS</option>
                <option value="Internships">Internships</option>
                <option value="PGs (MD/MS and DNB)">PGs (MD/MS and DNB)</option>
              </select>
              {submitted && errors.courseYear && (
                <small className="text-danger">{errors.courseYear}</small>
              )}
            </div>
          </div>

          {/* Laboratory Tour Preferences & Rationale */}
          <div className="section-header">
            Laboratory Tour Preferences & Rationale
          </div>
          <div className="row g-3 mb-2">
            <div className="col-md-4 mb-3">
              <label className="form-label">
                Tentative Preferred Date of Visit - From
              </label>
              <input
                type="date"
                className="form-control"
                name="fromDate"
                value={formData.fromDate}
                onChange={handleChange}
                ref={fieldRefs.fromDate}
              />
              {submitted && errors.fromDate && (
                <small className="text-danger">{errors.fromDate}</small>
              )}
            </div>
            <div className="col-md-4 mb-3">
              <label className="form-label">To Date</label>
              <input
                type="date"
                className="form-control"
                name="toDate"
                value={formData.toDate}
                onChange={handleChange}
                ref={fieldRefs.toDate}
              />
              {submitted && errors.toDate && (
                <small className="text-danger">{errors.toDate}</small>
              )}
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">Group Size (if applicable)</label>
              <input
                type="number"
                placeholder="Group Size (if applicable)"
                className="form-control"
                name="groupSize"
                value={formData.groupSize}
                onChange={handleChange}
                ref={fieldRefs.groupSize}
              />
            </div>
            <div className="col-md-4 mb-3">
              <label className="form-label">
                What is the duration of Laboratory Tour
                <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                placeholder="Enter Duration (ex: 1 week)"
                className="form-control"
                name="duration"
                value={formData.duration}
                onChange={handleChange}
                onBlur={handleBlur}
                ref={fieldRefs.duration}
              />
              {submitted && errors.duration && (
                <small className="text-danger">{errors.duration}</small>
              )}
            </div>
            {/* Theme, Rationale, Career Impact */}
            <div className="col-md-4 mb-3">
              <label className="form-label">
                Choose a Theme / Dept of Lab Medicine
                <span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                name="labTheme"
                value={formData.labTheme}
                onChange={handleChange}
                ref={fieldRefs.labTheme}
              >
                <option value="">Select</option>
                <option value="Hematology">Hematology</option>
                <option value="Microbiology">Microbiology</option>
                <option value="Biochemistry">Biochemistry</option>
                <option value="Pathology">Pathology</option>
                <option value="Other">Other</option>
              </select>
              {submitted && errors.labTheme && (
                <small className="text-danger">{errors.labTheme}</small>
              )}
            </div>
            {formData.labTheme === "Other" && (
              <div className="mb-3">
                <label className="form-label">Please specify</label>
                <input
                  type="text"
                  className="form-control"
                  name="labThemeOther"
                  value={formData.labThemeOther}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  ref={fieldRefs.labThemeOther}
                />
                {submitted && errors.labThemeOther && (
                  <small className="text-danger">{errors.labThemeOther}</small>
                )}
              </div>
            )}

            {/* Heard About */}
            <div className="col-md-4 mb-3">
              <label className="form-label">
                Where and how did you hear about Laboratory Tour Programme?
                <span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                name="heardAbout"
                value={formData.heardAbout}
                onChange={handleChange}
                ref={fieldRefs.heardAbout}
              >
                <option value="">Select</option>
                <option value="Website">Website</option>
                <option value="Friend">Friend</option>
                <option value="Social Media">Social Media</option>
                <option value="Other">Other</option>
              </select>
              {submitted && errors.heardAbout && (
                <small className="text-danger">{errors.heardAbout}</small>
              )}
            </div>
            {formData.heardAbout === "Other" && (
              <div className="mb-3">
                <label className="form-label">Please specify</label>
                <input
                  type="text"
                  className="form-control"
                  name="heardAboutOther"
                  value={formData.heardAboutOther}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  ref={fieldRefs.heardAboutOther}
                />
                {submitted && errors.heardAboutOther && (
                  <small className="text-danger">
                    {errors.heardAboutOther}
                  </small>
                )}
              </div>
            )}
            {/* Preferred Lab Location */}
            <div className="col-md-6 mb-3">
              <label className="form-label">
                MHL Laboratory Locations where Laboratory Tour is desired
              </label>
              <select
                className="form-select"
                name="preferredLabLocation"
                value={formData.preferredLabLocation}
                onChange={handleChange}
                ref={fieldRefs.preferredLabLocation}
              >
                <option value="">Select</option>
                <option value="Mumbai">Mumbai</option>
                <option value="Bangalore">Bangalore</option>
                <option value="Chennai">Chennai</option>
                <option value="Other">Other</option>
              </select>
              {submitted && errors.preferredLabLocation && (
                <small className="text-danger">
                  {errors.preferredLabLocation}
                </small>
              )}
            </div>
            {formData.preferredLabLocation === "Other" && (
              <div className="mb-3">
                <label className="form-label">Please specify</label>
                <input
                  type="text"
                  className="form-control"
                  name="preferredLabLocationOther"
                  value={formData.preferredLabLocationOther}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  ref={fieldRefs.preferredLabLocationOther}
                />
                {submitted && errors.preferredLabLocationOther && (
                  <small className="text-danger">
                    {errors.preferredLabLocationOther}
                  </small>
                )}
              </div>
            )}
            {/* Applicant Signature */}
            <div className="col-md-6 mb-3">
              <label className="form-label">
                Upload Applicant Signature
                <span className="small text-muted">
                  (Accepted formats: .jpg, .png, .jpeg. Max size: 10 MB){" "}
                  <span className="text-danger">*</span>
                </span>
              </label>
              <div className="file-upload-wrapper">
                <label className="file-upload-btn">
                  <i className="fa fa-upload"></i>
                  Upload Applicant Signature
                  <input
                    type="file"
                    accept=".jpg,.jpeg,.png"
                    name="applicantSignature"
                    onChange={handleChange}
                    ref={fieldRefs.applicantSignature}
                  />
                </label>
                <small className="form-text text-muted">
                  (Accepted formats: .jpg, .png,.jpeg, Max 10 MB)
                </small>
                {/* Show selected file name if file is chosen */}
                {formData.applicantSignature && (
                  <div className="mt-1 text-success">
                    Selected file: {formData.applicantSignature.name}
                  </div>
                )}
                {submitted && errors.applicantSignature && (
                  <small className="text-danger d-block">
                    {errors.applicantSignature}
                  </small>
                )}
              </div>
            </div>
            <div className=" mb-3">
              <label className="form-label">
                In 100 words, share your rationale
                <span className="text-danger">*</span>
              </label>
              <textarea
                className="form-control"
                placeholder="Enter"
                name="labRationale"
                value={formData.labRationale}
                onChange={handleChange}
                onBlur={handleBlur}
                rows={4}
                ref={fieldRefs.labRationale}
              ></textarea>
              {submitted && errors.labRationale && (
                <small className="text-danger">{errors.labRationale}</small>
              )}
            </div>

            <div className=" mb-3">
              <label className="form-label">
                How will this Laboratory Tour help you in your career as Health
                Care Professional?
                <span className="text-danger">*</span>
              </label>
              <textarea
                className="form-control"
                placeholder="Enter"
                name="labCareerImpact"
                value={formData.labCareerImpact}
                onChange={handleChange}
                onBlur={handleBlur}
                rows={4}
                ref={fieldRefs.labCareerImpact}
              ></textarea>
              {submitted && errors.labCareerImpact && (
                <small className="text-danger">{errors.labCareerImpact}</small>
              )}
            </div>
          </div>
          {/* Terms */}
          <div className="form-check mb-3">
            <input
              type="checkbox"
              className="form-check-input"
              name="agreeTerms"
              checked={formData.agreeTerms}
              onChange={handleChange}
              ref={fieldRefs.agreeTerms}
            />
            <label className="form-check-label">
              All details filled in this application form are true to my best
              understanding and signature is attached
              <span className="text-danger">*</span>
            </label>
            {submitted && errors.agreeTerms && (
              <small className="text-danger">{errors.agreeTerms}</small>
            )}
          </div>
          <div class="alert alert-info d-flex align-items-center" role="alert">
            <i class="fa fa-sticky-note me-2" aria-hidden="true"></i>
            <strong>Note:</strong> Please review the form carefully before
            submitting.
          </div>
          <div className="text-center mt-5">
            <button
              type="submit"
              className="btn btn-outline-success submit-btn rounded-3"
              disabled={loading}
            >
              {loading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Submitting...
                </>
              ) : (
                <>
                  <i className="fa fa-paper-plane me-2"></i>Submit Application
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LaboratoryTourForm;